import { get_axios_instance, api_variables, get_axios_file_instance, errorHandler, errorLogSheet } from '@/apis/variables.js';

var axios_instance_upload_template = get_axios_file_instance(api_variables.SERVICE_EMPLOYEE_LIST_PAYROLL_BULK_UPLOAD);
var axios_instance_download_template_New = get_axios_file_instance(api_variables.SERVICE_DOWNLOAD_EMPLOYEE_LIST_PAYROLL_TEMPLATE);
var axios_instance_upload_template_New = get_axios_file_instance(api_variables.SERVICE_EMPLOYEE_LIST_PAYROLL_BULK_UPLOAD);
var axios_instance_summary_data = get_axios_instance(api_variables.SERVICE_OFF_PAYROLL_SUMMARY_DATA);

const state = {
    data: [],
    employeeDataForOffCycle: [],
    variableearnings: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false
};

const mutations = {
    set: (state, payload) => {
        state.data = payload;
    },

    setVariableEarnings: (state, payload) => {
        if (payload) {
            state.variableearnings = payload;
        }
    },

    setEmployeeData: (state, payload) => {
        state.employeeDataForOffCycle = [];
        state.employeeDataForOffCycle = payload;
    },

    addEmployee: (state, payload) => {
        state.variableearnings = payload;
        // state.data.push(payload);
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    }
};

const actions = {
    async fileuploadTemplate({ commit }, payload) {
        try {
            // commit("setFetching", true);
            let res = await axios_instance_upload_template.post(``, payload);
            // commit("setFetching", false);
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async getEmployeeTemplate({commit},payload) {
        try {
          let res = await axios_instance_download_template_New.get(``, {
            params: payload
          });
          if (res.data.status) {
            const link = document.createElement("a");
            link.href = res.data.payload;
            link.setAttribute("download", "SelectedEmployeeTemplate"+ ".xlsx"); //or any other extension
            document.body.appendChild(link);
            link.click();
        }
        } catch (err) {
            throw errorHandler(err);
        }
      },

    async fileuploadTemplateNew({ commit }, payload) {
        try {
            // commit("setFetching", true);
            let res = await axios_instance_upload_template_New.post(``, payload);
            if(res.status == 200) {
                //if(res.data.payload.data.length!=0)
                 commit("setEmployeeData", [res.data.payload, payload]);
              }
            //   console.log(employeeData, ">>>>>>>>>>>>>....");
            // commit("setFetching", false);
            return res;
        } catch (error) {
            throw errorLogSheet(error.response);
        }
    },

    async createSummaryData({commit}, payload) {
        //console.log("[state/payroll/lopsandrlops/create] Adding...", payload);
      try {
        commit("setSaving", true);
        let res = await axios_instance_summary_data.post('', payload);
        commit("setSaving", false);
        //console.log("[state/payroll/lopsandrlops/create] res: ", res);
        return res;
      }catch (err) {
        //console.log("im in");
        commit("setSaving", false);
        throw errorHandler(err.response);
    }
    },
    
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};